<template>
  <div
    id="user-password-reset-request"
  >
    <h3>Reset Password</h3>

    <form
      class="form-horizontal"
      method="post"
      v-on:submit.prevent="submit"
    >

      <div
      class="form-group"
      >
        <label
          for="user_username"
          class="required"
        >
          Email Address
        </label>

        <input
          type="text"
          class="form-control"
          id="user_email"
          placeholder="Your Email Address"
          name="user[email]"
          v-model="email"

          autofocus
          required
        />
      </div>

      <div class="form-group">
        <button
          type="submit"
          class="btn btn-primary form-control"
        >
          Send Password Reset Confirmation Email

          <spinner
            size="small"
            v-if="base.loading"
          />
        </button>
      </div>
    </form>

  </div>
</template>
<script>
import FlashStore from '@/stores/FlashStore'

import Spinner from 'vue-simple-spinner'

import { mapState } from 'vuex'

export default {
  data () {
    return {
      email: undefined
    }
  },

  computed: mapState({
    base: state => state.base
  }),

  components: {
    'spinner': Spinner
  },

  methods: {
    submit () {
      this.$store.dispatch(
        `UserModule/requestPasswordReset`, this.email
      ).then(() => {
        this.$router.push({ name: 'sign_in' })

        FlashStore.result('Please click through the link emailed to you to reset your password, then return to this page!')
      }).catch(this.$root.processErrors)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/UserPasswordResetRequest.vue